export default __webpack_public_path__ + "static/media/corporate8.f6767dae.png";